<template>
    <div class="header">
        <div style="display: flex;align-items: center">
            <img v-if="college.logo" style="width: 50px;height: 50px;margin-left: 60px" :src="college.logo" />
            <span v-if="college.name" style="padding-left: 10px;color: #333333;font-weight: 600;font-size: 18px">{{ college.name }}</span>
        </div>
        <div style="margin-right: 20px">
            <el-button type="text"  @click="loginOut">退出登录</el-button>
        </div>
    </div>
</template>

<script>
	import { getvCode, getSmsvCode, login, getToken, getDepartment,getSignDetail,getCollege,getCollegeSetting, getSignchip} from '@/api/login'
	export default {
        data(){
        	return {
        		college: {name:'',logo:''},
                su_number: null
            }
        },
        created(){
            if (this.$route.params.id) {
                this.su_number = this.$route.params.id
                this.getSignDetail()
            }
        },
        methods:{
        //获取签约信息
        async getSignDetail() {
            const res = await getSignchip(this.su_number)
            //department_sign_reminder
            if(res.department_sign_reminder)
            {
                this.alertText = res.department_sign_reminder;
                this.alertChips = 1;
            }
            this.getCollegeInfo(res.collegeid)
        },
        //获取高校信息
        async getCollegeInfo(id) {
            const res = await getCollege(id)
            if(res){
                this.college = res
            }
        },
        loginOut(){
            this.$confirm('确定退出登录吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            })
            .then(async () => {
                localStorage.removeItem('tokenInfo')
                localStorage.removeItem('accountid')
                    if (this.su_number) {
                        this.$router.push('/login/' + this.su_number)
                    } else {
                        this.$router.push('/login')
                    }
            })
            .catch(() => {})
        }

        }
	}
</script>

<style scoped rel="stylesheet/scss" lang="scss" >
    .header{
        width: 100%;
        height: 72px;
        border-bottom:1px solid #EEEEEE;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
</style>
